import { DatesRangeValue } from '@mantine/dates';
import {
  AdminStatsDailyPointDto,
  AdminStatsOverviewDto,
} from 'src/api/FiretrolApiClient';
import {
  useAdminStatsDaily,
  useAdminStatsOverview,
} from 'src/api/queries/chatAdmin/useAdminStatsQueries';

export interface IUseAdminStatsResult {
  overview: AdminStatsOverviewDto | null;
  daily: AdminStatsDailyPointDto[];
  loading: boolean;
}

/**
 * Loads the overview + daily-series stats for the AI Assistant admin views.
 * Shared between OverviewTab (userId undefined) and UserDetail (userId set)
 * since both endpoints take the same optional userId/from/to shape.
 */
export const useAdminStats = (
  userId: number | undefined,
  [from, to]: DatesRangeValue,
): IUseAdminStatsResult => {
  const overviewQuery = useAdminStatsOverview({ userId, from, to });
  const dailyQuery = useAdminStatsDaily({ userId, from, to });

  return {
    overview: overviewQuery.data ?? null,
    daily: dailyQuery.data ?? [],
    loading: overviewQuery.isLoading || dailyQuery.isLoading,
  };
};
